import { Injectable } from '@angular/core';

import { GatewayAPIService } from '../../core/gateway-api.service';
import { AuthService } from '../../core/auth.service';
import { Role } from './role';
import { Page } from '../../components/ui/filterable-table/tableViewAbstractComponent';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(
    private api: GatewayAPIService,
    private auth: AuthService,
  ) {}

  public saveRole(
    roleName: string,
    grantNamespaces: string[],
    revokeNamespaces: string[],
  ): Promise<void> {
    return this.api.apiCallSane(
      '/admin/role',
      'PUT',
      this.api.getDefaultHeaders(),
      null,
      {
        name: roleName,
        grant: grantNamespaces,
        revoke: revokeNamespaces,
      },
      { authenticate: true, setRoot: true },
    );
  }

  getAll(): Promise<Page<Role>> {
    return this.api
      .apiCallSane(
        '/admin/roles',
        'GET',
        this.api.getDefaultHeaders(),
        {},
        null,
        { authenticate: true, setRoot: true },
      )
      .then((response: Page<Role>) => new Page<Role>(response));
  }
}
